import request from "@/libs/request";
import { appName } from "../../config/url";

/**
 * 账号密码登录
 * @param phone
 * @param password
 */
export const loginPwd = (phone: string, password: string) => {
    let loginType = "PHONE";
    return request({
        url: "/auth/login/pwd",
        method: "post",
        data: { phone, password, loginType, appName }
    });
};

/**
 *  微信登录
 * @param code
 */
export const getWxLoginAccess = (code: string) => {
    return request({
        url: "/auth/wechat/login/access",
        method: "get",
        params: { code, appName }
    });
};

/**
 * 注册之后绑定微信
 * @param code
 */
export const getWxLoginBind = (code: string, userId: string) => {
    return request({
        url: "/auth/wechat/login/bind",
        method: "get",
        params: { code, userId, appName }
    });
};

/**
 * 登录发送验证码
 * @param region
 * @param phone
 */
export const sendLoginCaptcha = (region: string, phone: string) => {
    return request({
        url: "/auth/login/captcha",
        method: "get",
        params: { region, phone }
    });
};

/**
 * 手机验证码登录
 * @param region
 * @param phone
 * @param code
 */
export const loginTelCode = (region: string, phone: string, code: string) => {
    let source = "smh";
    return request({
        url: "/auth/login/code",
        method: "post",
        data: { region, phone, code, source, appName }
    });
};

/**
 *  服务号登录
 * @param code
 */
export const getWxInfo = (code: any) => {
    let appName = "UAI-SA";
    return request({
        url: "/auth/wechat/login/uai/access",
        method: "get",
        params: { appName, code }
    });
};
